import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { it } from 'vuetify/locale'

export const vuetify = createVuetify({
  locale: {
    locale: 'it',
    messages: { it }
  },
  defaults : {
    VInput : {
      density : 'compact',
    },
    VTextField : {
      variant : 'outlined',
      rounded : 'lg',
      flat : true,
      color: 'primary',
      density : 'compact',
    },
    VFileInput : {
      variant : 'outlined',
      rounded : 'lg',
      flat : true,
      color: 'primary',
      density : 'compact',
    },
    VTextarea : {
      variant : 'outlined',
      rounded : 'lg',
      flat : true,
      color: 'primary',
      density : 'compact',
    },
    VAutocomplete : {
      variant : 'outlined',
      rounded : 'lg',
      flat : true,
      color: 'primary',
      density : 'compact',
    },
    VSelect : {
      variant : 'outlined',
      rounded : 'lg',
      flat : true,
      color: 'primary',
      density : 'compact',
    },
    VSwitch : {
      color: 'primary',
      density : 'compact',
    },
    VBtn : {

    },
    VCard : {
      rounded : 'lg'
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#f39530',
          "on-primary": '#ffffff',
          secondary: '#000000',
          error: '#d43a2d',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#f7d137'
        }
      }
    }
  }
})